module.exports = __webpack_public_path__ + "img/DevOps-Best-Practice_1080.e31d4c37.png";